/* unplugin-vue-components disabled */import script from "./informationSwiperBox.vue?vue&type=script&lang=jsx"
export * from "./informationSwiperBox.vue?vue&type=script&lang=jsx"

import "./informationSwiperBox.vue?vue&type=style&index=0&id=5633b8f5&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5633b8f5"]])

export default __exports__